import { render, staticRenderFns } from "./CoopnetMachineComponent.vue?vue&type=template&id=c06dab04&scoped=true&"
import script from "./CoopnetMachineComponent.vue?vue&type=script&lang=js&"
export * from "./CoopnetMachineComponent.vue?vue&type=script&lang=js&"
import style0 from "./CoopnetMachineComponent.vue?vue&type=style&index=0&id=c06dab04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06dab04",
  null
  
)

export default component.exports